<template>
	<div  class="body-mid" v-if="loading">
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					项目需求
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;" v-if="Projectneed.data.length">
				<div v-for="(item, index) in Projectneed.data" :key="item.data">
				<div class="main-item" >
					<div class="main-item-pic">
						<img :src='getImgSrc(item.image)' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span style="margin-right: 10px;color: #0052D9;"@click='$router.push(`/projectNeed/editDraft?id=${item.id}`)'>编辑</span> 
				<div style="width: 3px;height: 20px;background: #888;"></div> <span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(1,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer" @click="loadingMore(1)" v-if="Projectneed.last_page !== Projectneed.current_page & Projectneed.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					资源工具
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;" v-if="Instrument.data.length">
				<div v-for="(item, index) in Instrument.data" :key="item.id">
				<div class="main-item" >
					<div class="main-item-pic">
						<img :src='getImgSrc(item.image)' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span style="margin-right: 10px;color: #0052D9;"@click='$router.push(`/zyTools/editDraft?id=${item.id}`)'>编辑</span> 
				<div style="width: 3px;height: 20px;background: #888;"></div> 
				<span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(2,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer"  @click="loadingMore(2)" v-if="Instrument.last_page !== Instrument.current_page & Instrument.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					解决方案
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;"  v-if="Solution.data.length">
				<div v-for="(item, index) in Solution.data" :key="item.id">
				<div class="main-item" >
					<div class="main-item-pic">
						<img :src='getImgSrc(item.image)' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span style="margin-right: 10px;color: #0052D9;" @click='$router.push(`/solutionDetail/editDraft?id=${item.id}`)'>编辑</span>
				 <div style="width: 3px;height: 20px;background: #888;"></div> 
				<span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(3,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer"   @click="loadingMore(3)" v-if="Solution.last_page !== Solution.current_page & Solution.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					产品服务
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;" v-if="Project.data.length">
				<div v-for="(item, index) in Project.data" :key="item.id">
				<div class="main-item" >
					<div class="main-item-pic">
						<img :src='getImgSrc(item.image)' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span  @click='$router.push(`/productService/editDraft?id=${item.id}`)' style="margin-right: 10px;color: #0052D9;">编辑</span> <div style="width: 3px;height: 20px;background: #888;"></div> 
				<span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(4,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer"   @click="loadingMore(4)" v-if="Project.last_page !== Project.current_page & Project.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 150px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					资源工具求助
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;" v-if="InstrumentSeekHelp.data.length">
				<div v-for="(item, index) in InstrumentSeekHelp.data" :key="item.id">
				<div class="main-item" >
					<div class="main-item-pic">
						<img :src='getImgSrc(item.image)' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span  @click='$router.push(`/zyTools/seekHelpDrafts?id=${item.id}`)' style="margin-right: 10px;color: #0052D9;">编辑</span> <div style="width: 3px;height: 20px;background: #888;"></div> 
				<span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(8,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer"   @click="loadingMore(8)" v-if="InstrumentSeekHelp.last_page !== InstrumentSeekHelp.current_page & InstrumentSeekHelp.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 150px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					解决方案求助
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;" v-if="SolutionSeekHelp.data.length">
				<div v-for="(item, index) in SolutionSeekHelp.data" :key="item.id">
				<div class="main-item" >
					<div class="main-item-pic">
						<img :src='getImgSrc(item.image)' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span  @click='$router.push(`/solutionDetail/seekHelpDrafts?id=${item.id}`)' style="margin-right: 10px;color: #0052D9;">编辑</span> <div style="width: 3px;height: 20px;background: #888;"></div> 
				<span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(9,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer"   @click="loadingMore(9)" v-if="SolutionSeekHelp.last_page !== SolutionSeekHelp.current_page & SolutionSeekHelp.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 150px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					产品服务求助
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;" v-if="ProjectSeekHelp.data.length">
				<div v-for="(item, index) in ProjectSeekHelp.data" :key="item.id">
				<div class="main-item" >
					<div class="main-item-pic">
						<img :src='getImgSrc(item.image)' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span  @click='$router.push(`/productService/seekHelpDrafts?id=${item.id}`)' style="margin-right: 10px;color: #0052D9;">编辑</span> <div style="width: 3px;height: 20px;background: #888;"></div> 
				<span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(10,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer"   @click="loadingMore(10)" v-if="ProjectSeekHelp.last_page !== ProjectSeekHelp.current_page & ProjectSeekHelp.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 150px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					资源工具应助
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;" v-if="InstrumentYZ.data.length">
				<div v-for="(item, index) in InstrumentYZ.data" :key="item.id">
				<div class="main-item" >
					<div class="main-item-pic">
						<img src='../../assets/images/computer.png' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span  @click='$router.push(`/zyTools/YzNeedDraft?id=${item.id}`)' style="margin-right: 10px;color: #0052D9;">编辑</span> <div style="width: 3px;height: 20px;background: #888;"></div> 
				<span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(5,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer"   @click="loadingMore(5)" v-if="InstrumentYZ.last_page !== InstrumentYZ.current_page & InstrumentYZ.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 150px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					解决方案应助
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;" v-if="SolutionYZ.data.length">
				<div v-for="(item, index) in SolutionYZ.data" :key="item.id">
				<div class="main-item" >
					<div class="main-item-pic">
						<img src='../../assets/images/computer.png' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span   @click='$router.push(`/solutionDetail/YzNeedDrafts?id=${item.id}`)' style="margin-right: 10px;color: #0052D9;">编辑</span> <div style="width: 3px;height: 20px;background: #888;"></div> 
				<span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(6,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer"   @click="loadingMore(6)" v-if="SolutionYZ.last_page !== SolutionYZ.current_page & SolutionYZ.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
		<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 150px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					产品服务应助
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;" v-if="ProjectYZ.data.length">
				<div v-for="(item, index) in ProjectYZ.data" :key="item.id">
				<div class="main-item" >
					<div class="main-item-pic">
						<img src='../../assets/images/computer.png' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						{{item.title}}
					</div>
				</div>
				<div class="bottom"><span  @click='$router.push(`/productService/YzNeedDraft?id=${item.id}`)' style="margin-right: 10px;color: #0052D9;">编辑</span> <div style="width: 3px;height: 20px;background: #888;"></div> 
				<span class="delitem" style="margin-left: 10px;" @click="deleteDrafts(7,item.id)">删除</span></div>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200"></el-empty>
			</div>
			<div class="body-mid-footer"   @click="loadingMore(7)" v-if="ProjectYZ.last_page !== ProjectYZ.current_page & ProjectYZ.last_page !== 0">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div>
	<!-- 	<div style="background: #FFFFFF;margin-bottom: 20px;padding-bottom: 20px;width: 100%;">
			<div class="body-mid-top">
				<div style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;
		       	font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
					课题定位
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;">
				<div v-for="(item, index) in 5" :key="index">
				<div class="main-item" >
					<div class="main-item-pic">
						<img src='../../assets/images/computer.png' alt="">
					</div>
					<div class="main-item-title" style=" overflow: hidden;
		                      text-overflow: ellipsis;
		                      max-height: calc(2em + 8px);">
						惯性颗粒流SPH模拟
					</div>
				</div>
				<div class="bottom"><span style="margin-right: 10px;color: #0052D9;">编辑</span> <div style="width: 3px;height: 20px;background: #888;"></div> <span class="delitem" style="margin-left: 10px;">删除</span></div>
				</div>
			</div>
			<div class="body-mid-footer">
				加载更多<img src='../../assets/images/darrwo.png' alt="">
			</div>
		</div> -->
	</div>
</template>

<script>
	export default{
		data() {
			return{
				Projectneed:[],
				Instrument:[],
				Solution:[],
				Project:[],
				loading:false,
				ProjectneedYZ:[],
				InstrumentYZ:[],
				SolutionYZ:[],
				ProjectYZ:[],
				InstrumentSeekHelp:[],
				SolutionSeekHelp:[],
				ProjectSeekHelp:[],
			}
		},
		created() {
			this.getProjectDrafts()
		},
		methods:{
			async getProjectDrafts(){
				this.showLoading();
				const list = await this.$api.getDraftProjectneed()
				this.Projectneed = list.data
				const tool = await this.$api.getDraftInstrument()
				this.Instrument = tool.data
				const scheme = await this.$api.getDraftScheme()
				this.Solution = scheme.data
				const pro = await this.$api.getDraftProduct()
				this.Project = pro.data
				
				const toolSH = await this.$api.getToolSeekHelpDrafts()
				this.InstrumentSeekHelp = toolSH.data
				
				const solutionSH = await this.$api.getSolutionSeekHelpDrafts()
				this.SolutionSeekHelp = solutionSH.data
				
				const projectSH = await this.$api.getProductSeekHelpDrafts()
				this.ProjectSeekHelp = projectSH.data
				
				const toolYz = await this.$api.myToolYZdrafts() 
				this.InstrumentYZ = toolYz.data
				const schemeYZ = await this.$api.mySolutionYZdrafts() 
				this.SolutionYZ = schemeYZ.data
				const proYZ = await this.$api.myProductYZdrafts()
				this.ProjectYZ = proYZ.data
				this.loading = true
				this.hideLoading();
			},
			async loadingMore(type){
				if(type == 1 & this.Projectneed.last_page > this.Projectneed.current_page){
					let page = this.Projectneed.current_page
					const list = await this.$api.getDraftProjectneed({page:++page})
					this.Projectneed.data = this.Projectneed.data.concat(list.data.data)
					this.Projectneed.current_page = list.data.current_page
				}
				if(type == 2 & this.Instrument.last_page > this.Instrument.current_page){
					let page = this.Instrument.current_page
					const list = await this.$api.getDraftInstrument({page:++page})
					this.Instrument.data = this.Instrument.data.concat(list.data.data)
					this.Instrument.current_page = list.data.current_page
				}
				if(type == 3 & this.Solution.last_page > this.Solution.current_page){
					let page = this.Solution.current_page
					const list = await this.$api.getDraftScheme({page:++page})
					this.Solution.data = this.Solution.data.concat(list.data.data)
					this.Solution.current_page = list.data.current_page
				}
				if(type == 4 & this.Project.last_page > this.Project.current_page){
					let page = this.Project.current_page
					const list = await this.$api.getDraftProduct({page:++page})
					this.Project.data = this.Project.data.concat(list.data.data)
					this.Project.current_page = list.data.current_page
				}
				if(type == 5 & this.InstrumentYZ.last_page > this.InstrumentYZ.current_page){
					let page = this.InstrumentYZ.current_page
					const list = await this.$api.myToolYZdrafts({page:++page})
					this.InstrumentYZ.data = this.InstrumentYZ.data.concat(list.data.data)
					this.InstrumentYZ.current_page = list.data.current_page
				}
				if(type == 6 & this.SolutionYZ.last_page > this.SolutionYZ.current_page){
					let page = this.SolutionYZ.current_page
					const list = await this.$api.mySolutionYZdrafts({page:++page})
					this.SolutionYZ.data = this.SolutionYZ.data.concat(list.data.data)
					this.SolutionYZ.current_page = list.data.current_page
				}
				if(type == 7 & this.ProjectYZ.last_page > this.ProjectYZ.current_page){
					let page = this.ProjectYZ.current_page
					const list = await this.$api.myProductYZdrafts({page:++page})
					this.ProjectYZ.data = this.ProjectYZ.data.concat(list.data.data)
					this.ProjectYZ.current_page = list.data.current_page
				}
				if(type == 8 & this.InstrumentSeekHelp.last_page > this.InstrumentSeekHelp.current_page){
					let page = this.InstrumentSeekHelp.current_page
					const list = await this.$api.getToolSeekHelpDrafts({page:++page})
					this.InstrumentSeekHelp.data = this.InstrumentSeekHelp.data.concat(list.data.data)
					this.InstrumentSeekHelp.current_page = list.data.current_page
				}
				if(type == 9 & this.SolutionSeekHelp.last_page > this.SolutionSeekHelp.current_page){
					let page = this.SolutionSeekHelp.current_page
					const list = await this.$api.getSolutionSeekHelpDrafts({page:++page})
					this.SolutionSeekHelp.data = this.SolutionSeekHelp.data.concat(list.data.data)
					this.SolutionSeekHelp.current_page = list.data.current_page
				}
				if(type == 10 & this.ProjectSeekHelp.last_page > this.ProjectSeekHelp.current_page){
					let page = this.ProjectSeekHelp.current_page
					const list = await this.$api.getProductSeekHelpDrafts({page:++page})
					this.ProjectSeekHelp.data = this.ProjectSeekHelp.data.concat(list.data.data)
					this.ProjectSeekHelp.current_page = list.data.current_page
				}
			},
			async deleteDrafts(type,id){
				
				let info 
				if(type == 1){
					info = await this.$api.getDraftProjectneedDel({projectneed_id:id})
					if(info.code == 1) this.Projectneed.data = this.Projectneed.data.filter(obj => obj.id !== id);
				}
				if(type == 2){
					info = await this.$api.DraftInstrumentDel({instrument_id:id})
					if(info.code == 1) this.Instrument.data = this.Instrument.data.filter(obj => obj.id !== id);
				}
				if(type == 3){
					info = await this.$api.DraftSchemeDel({scheme_id:id})
					if(info.code == 1) this.Solution.data = this.Solution.data.filter(obj => obj.id !== id);
				}
				if(type == 4){
					info = await this.$api.DraftProductDel({product_id:id})
					if(info.code == 1) this.Project.data = this.Project.data.filter(obj => obj.id !== id);
				}
				if(type == 5){
					info = await this.$api.delMyToolsDrafts({id:id})
					if(info.code == 1) this.InstrumentYZ.data = this.InstrumentYZ.data.filter(obj => obj.id !== id);
				}
				if(type == 6){
					info = await this.$api.delMySolutionDrafts({id:id})
					if(info.code == 1) this.SolutionYZ.data = this.SolutionYZ.data.filter(obj => obj.id !== id);
				}
				if(type == 7){
					info = await this.$api.delMyProductDrafts({id:id})
					if(info.code == 1) this.ProjectYZ.data = this.ProjectYZ.data.filter(obj => obj.id !== id);
				}
				if(type == 8){
					info = await this.$api.delMyToolSeekHlepDrafts({id:id})
					if(info.code == 1) this.InstrumentSeekHelp.data = this.InstrumentSeekHelp.data.filter(obj => obj.id !== id);
				}
				if(type == 9){
					info = await this.$api.delMySolutionSeekHlepDrafts({id:id})
					if(info.code == 1) this.SolutionSeekHelp.data = this.SolutionSeekHelp.data.filter(obj => obj.id !== id);
				}
				if(type == 10){
					info = await this.$api.delMyProductSeekHlepDrafts({id:id})
					if(info.code == 1) this.ProjectSeekHelp.data = this.ProjectSeekHelp.data.filter(obj => obj.id !== id);
				}
				if(info.code == 1){
					this.$message({
						message:info.msg,
						 type: 'success'
					})
				}else{
					this.$message({
						message:info.msg,
						 type: 'warning'
					})
				}
			}
		}
		
		
	}
</script>

<style lang="less" scoped>
	.delitem:hover{
		color: red;
	}
	.body-mid {
		margin: 0 20px;
		width: 1120px;
		box-sizing: border-box;
	}
	.body-mid-top {
		margin-bottom: 15px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 20px;
		padding-right: 20px;
	}
	
	.body-mid-main {
		display: flex;
		flex-wrap: wrap;
	
		justify-content: flex-start;
		.bottom{
			display: flex;
			justify-content: center;
			align-items: center;
			margin-left: 28px;
			span{
				cursor: pointer;
			}
		}
	}
	.body-mid-footer {
		width: 95%;
		margin: 0 auto;
		margin-top: 20px;
		display: flex;
		padding: 20px;
		box-sizing: border-box;
		height: 50px;
		background: #F6F6F6;
		justify-content: center;
		font-size: 18px;
		cursor: pointer;
		align-items: center;
	
		&>img {
			margin-left: 20px;
			width: 16px;
			height: 16px;
		}
	}
	.main-item {
		text-align: center;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 15px;
		box-sizing: border-box;
		transition: all .3s;
	}
	.main-item {
		margin: 13px;
		margin-left: 25px;
		width: 180px;
		height: 210px;
		border: 1px solid #BFBFBF;
		transition: all .3;
		cursor: pointer;
	}
	.main-item:hover{
		transform: scale(1.02);
		box-shadow:  0 3px 5px #5e5e5e;
	}
	.main-item-pic {
		width: 100%;
		height: 100px;
		border-radius: 50%;
		text-align: center;
		line-height: 100px;
		overflow: hidden;
		display: flex;
		justify-content: center;
	}
	
	.main-item-pic>img {
		width: 100px;
		height: 100%;
	}
</style>